<template>
  <div class="home" id="home">
    <div class="imagesContainer">
      <a href="https://mago.cloud/it" target="_blank" class="imgPartner"
        ><img src="@/assets/images/loghi/LogoMagoCloud.png"
      /></a>
      <a href="https://www.zucchetti.it/" target="_blank" class="imgPartner"
        ><img src="@/assets/images/loghi/zuchpartner.png"
      /></a>
      <div class="imgPartner">
        <img src="@/assets/images/loghi/confindustria.png" />
      </div>
    </div>
    <div class="logoContainer">
      <div class="fullscreen-bg">
        <video
          loop
          muted
          autoplay
          poster="@/assets/media/video/poster.jpg"
          class="fullscreen-video"
          preload="none"
          playsinline
        >
          <source src="@/assets/media/video/bb.webm" type="video/webm" />
          <source src="@/assets/media/video/bb.mp4" type="video/mp4" />
        </video>
      </div>

      <svg
        class="svgLogo"
        width="1080px"
        height="1130px"
        viewBox="0 0 10800 11300"
      >
        <defs>
          <path
            id="layerBackground"
            d="M3920 11284 c-520 -66 -968 -197 -1418 -414 -212 -102 -310 -159 -517 -295 -664 -437 -1214 -1068 -1561 -1790 -211 -439 -353 -934 -409 -1423 -14 -119 -16 -221 -12 -590 4 -482 9 -536 73 -852 155 -756 507 -1466 1014 -2043 255 -290 580 -574 895 -782 207 -136 305 -193 517 -295 480 -231 1009 -379 1523 -425 207 -19 653 -19 860 0 600 54 1246 256 1778 556 160 90 427 272 582 396 498 398 906 900 1200 1478 261 512 420 1081 466 1668 15 194 6 726 -15 897 -103 817 -391 1531 -883 2187 -281 374 -686 753 -1088 1018 -207 136 -305 193 -517 295 -455 219 -907 351 -1428 415 -164 20 -901 20 -1060 -1z"
          />
        </defs>
        <g id="layerBackgroundContainer">
          <use xlink:href="#layerBackground" fill="#0f1213" stroke="none" />
        </g>
        <g
          id="layerPage"
          fill="#fff"
          stroke="none"
          @click="$router.push('brand')"
        >
          <path
            d="M1730 7385 l0 -1275 195 0 195 0 0 142 0 143 38 -64 c71 -122 196 -212 349 -252 101 -27 286 -29 388 -5 102 24 219 86 298 157 215 194 316 501 286 870 -15 189 -41 284 -117 434 -64 126 -182 243 -302 303 -119 58 -199 75 -355 76 -152 1 -207 -10 -325 -66 -69 -33 -100 -57 -172 -129 l-88 -87 0 514 0 514 -195 0 -195 0 0 -1275z m981 171 c162 -35 270 -138 326 -314 34 -106 43 -301 19 -422 -42 -210 -159 -351 -330 -396 -77 -21 -222 -18 -297 5 -204 64 -319 262 -319 548 0 167 40 302 118 406 116 153 287 214 483 173z"
          />
          <path
            d="M5960 8644 c-233 -42 -418 -161 -495 -318 -19 -39 -40 -95 -45 -125 -19 -100 -39 -91 204 -91 l213 0 6 36 c18 110 134 179 323 191 176 11 352 -39 420 -120 73 -86 103 -216 104 -442 l0 -150 -32 40 c-156 193 -373 277 -641 248 -382 -43 -627 -316 -678 -756 -14 -122 -7 -343 15 -442 71 -329 275 -563 553 -636 101 -27 287 -29 388 -5 158 38 293 133 363 256 l31 55 3 -135 3 -135 198 -3 197 -2 0 852 c0 511 -4 897 -10 963 -43 453 -217 655 -620 720 -118 19 -395 18 -500 -1z m346 -1085 c90 -17 162 -55 229 -123 115 -116 165 -255 165 -458 0 -268 -84 -439 -257 -525 -70 -34 -82 -37 -187 -41 -169 -7 -260 25 -358 123 -107 108 -152 245 -151 460 1 157 21 256 70 348 92 168 285 254 489 216z"
          />
          <path
            d="M4174 7905 c-179 -32 -312 -108 -426 -243 -165 -195 -241 -541 -193 -880 32 -226 116 -395 268 -539 136 -129 290 -186 502 -185 250 1 438 93 540 266 l34 59 3 -134 3 -134 198 -3 197 -2 0 870 0 870 -197 -2 -198 -3 -3 -108 -3 -108 -44 55 c-152 186 -412 270 -681 221z m365 -350 c90 -22 153 -59 219 -130 120 -128 175 -322 152 -539 -33 -314 -192 -476 -468 -476 -157 0 -247 35 -340 134 -101 106 -144 237 -144 441 -1 152 18 247 67 345 93 185 300 275 514 225z"
          />
          <path
            d="M7895 7910 c-221 -30 -411 -132 -547 -294 -251 -298 -275 -836 -52 -1172 188 -283 491 -417 869 -384 254 22 454 119 587 284 122 152 197 386 198 621 l0 80 -698 -3 -698 -3 8 68 c25 213 141 367 319 425 48 16 90 21 169 21 187 1 305 -47 419 -169 37 -39 78 -93 92 -118 13 -25 26 -46 29 -46 3 0 70 36 149 80 79 44 149 80 155 80 31 1 38 17 22 48 -8 16 -21 36 -28 44 -7 7 -33 39 -58 72 -140 184 -327 306 -540 352 -83 18 -304 26 -395 14z m630 -1177 c-25 -132 -94 -230 -205 -286 -94 -47 -167 -60 -295 -54 -232 11 -367 120 -439 355 l-7 22 476 0 477 0 -7 -37z"
          />
        </g>
        <g
          id="layer93"
          fill="#0f1213"
          stroke="none"
          class="redHoverAndZoom"
          @click="$router.push('/history')"
        >
          <path
            d="M9243 7004 c-29 -14 -53 -30 -53 -36 0 -10 35 -59 170 -233 25 -33 49 -64 52 -70 4 -6 -25 -10 -80 -10 -98 0 -131 -13 -195 -74 -59 -56 -80 -103 -85 -198 -8 -151 46 -250 167 -307 59 -27 76 -30 156 -30 140 0 220 45 277 154 18 34 24 65 26 131 4 77 1 94 -28 165 -17 43 -57 120 -88 169 -74 117 -251 365 -260 364 -4 0 -31 -12 -59 -25z m199 -493 c73 -28 110 -160 68 -245 -54 -112 -207 -121 -277 -16 -44 64 -25 211 31 243 65 37 116 43 178 18z"
          />
          <path
            d="M10029 6990 c-115 -20 -196 -107 -215 -227 l-7 -43 74 0 74 0 17 48 c22 61 71 92 148 92 92 0 149 -44 165 -126 19 -102 -62 -184 -182 -184 l-33 0 0 -65 0 -65 40 0 c57 0 118 -27 135 -61 52 -99 -31 -203 -145 -184 -45 8 -97 52 -102 88 -3 20 -9 22 -75 25 -84 3 -84 3 -58 -84 17 -59 60 -104 130 -136 40 -18 68 -22 140 -23 80 0 96 3 150 30 82 41 118 99 123 197 6 107 -25 171 -102 211 l-30 15 31 6 c37 8 87 58 107 108 24 56 21 181 -5 234 -24 51 -77 100 -133 125 -48 21 -182 31 -247 19z"
          />
          <path
            d="M10640 6293 c-91 -35 -118 -149 -49 -211 58 -51 128 -51 179 0 26 26 30 37 30 87 0 33 -6 65 -15 77 -27 40 -101 63 -145 47z m111 -52 c41 -42 41 -98 -2 -140 -42 -43 -98 -43 -140 -2 -64 65 -20 171 71 171 33 0 48 -6 71 -29z"
          />
          <path
            d="M10630 6170 l0 -80 44 0 c65 0 101 47 61 80 -11 9 -12 17 -5 30 6 10 10 26 10 34 0 28 -26 17 -43 -19 -9 -19 -21 -35 -27 -35 -5 0 -10 16 -10 35 0 24 -5 35 -15 35 -12 0 -15 -16 -15 -80z m78 -32 c3 -13 -3 -18 -22 -18 -20 0 -26 5 -26 21 0 15 5 20 22 17 13 -2 24 -11 26 -20z"
          />
        </g>
        <g id="layerServizi" fill="#0f1213" stroke="none">
          <path
            id="logoServices"
            class="redHoverAndZoom"
            @mouseover="moveLogoInfo($event, 'service')"
            @click="$router.push('service')"
            @mouseleave="hideLogoInfo"
            d="M7035 3226 c-207 -25 -453 -124 -600 -241 -107 -86 -190 -169 -235 -236 -23 -33 -47 -62 -54 -65 -19 -7 -81 -144 -110 -241 -102 -339 -31 -705 190 -990 67 -85 125 -139 234 -215 83 -58 226 -130 310 -156 289 -88 627 -59 880 76 89 47 246 161 296 214 240 253 347 605 288 949 -52 302 -242 581 -507 745 -138 85 -267 134 -421 159 -104 17 -133 17 -271 1z"
          ></path>
          <path
            id="logoSoftware"
            class="redHoverAndZoom"
            @mouseover="moveLogoInfo($event, 'software')"
            @click="$router.push('software')"
            @mouseleave="hideLogoInfo"
            d="M3831 2505 c-46 -8 -121 -25 -166 -39 -46 -14 -91 -26 -100 -26 -10 0 -53 -18 -96 -39 -356 -178 -617 -529 -685 -921 -22 -130 -15 -379 15 -500 102 -405 382 -728 768 -886 178 -72 222 -79 503 -79 224 1 252 3 330 24 235 63 428 178 603 360 175 182 294 413 332 649 19 111 19 333 0 442 -41 252 -176 503 -366 685 -84 80 -222 185 -245 185 -6 0 -49 17 -95 39 -95 43 -225 83 -348 106 -101 18 -330 18 -450 0z"
          />
          <path
            id="logoHardware"
            class="redHoverAndZoom"
            @mouseover="moveLogoInfo($event, 'hardware')"
            @click="$router.push('hardware')"
            @mouseleave="hideLogoInfo"
            d="M9075 5213 c-245 -16 -469 -116 -626 -279 -133 -139 -197 -244 -256 -423 -127 -383 32 -827 381 -1064 155 -105 311 -156 507 -164 209 -9 337 16 506 100 175 86 324 229 417 398 176 321 154 719 -57 1018 -95 134 -250 264 -391 326 -143 63 -334 98 -481 88z"
          />
        </g>
      </svg>

      <div class="logoInfo" ref="logoInfo">Page93</div>

      <div class="missionText is-hidden-touch">
        <span>capire le imprese</span> <span>risolvere i problemi</span>
        <span>innovare per realizzare il futuro</span>
      </div>

      <div class="bottomMenu">
        <a
          href="https://www.linkedin.com/company/page93-s-r-l/"
          class="bottomLink"
          ><img src="@/assets/images/icons/linkedin.svg" />&nbsp;</a
        >
        <a @click="$router.push('lavoraconnoi')" class="bottomLink"
          >Lavora con noi</a
        >
        <a @click="scrollToAboutUs" class="bottomLink">Contatti</a>
      </div>
    </div>
    <Info />
    <Footer />
  </div>
</template>

<script>
//import TopLogoBar from '@/components/TopLogoBar'
import Info from "@/views/Info";
import Footer from "@/components/Footer";
import anime from "animejs";

export default {
  name: "home",
  components: {
    // TopLogoBar,
    Info,
    Footer,
  },
  data() {
    return {};
  },
  methods: {
    scrollToHome() {
      this.$scrollTo("#home");
    },
    scrollToAboutUs() {
      this.$scrollTo("#aboutUs");
    },
    moveLogoInfo(event, text) {
      if (this.$refs.logoInfo == null || this.$refs.logoInfo.style == null)
        return;

      this.$refs.logoInfo.style.display = "block";
      this.$refs.logoInfo.innerHTML = text;
      let targetRect = event.target.getBoundingClientRect();
      let logoInfoRect = this.$refs.logoInfo.getBoundingClientRect();
      this.$refs.logoInfo.style.top =
        targetRect.top +
        targetRect.height / 2 -
        logoInfoRect.height / 2 +
        window.scrollY +
        "px";
      this.$refs.logoInfo.style.left =
        targetRect.left + targetRect.width / 2 - logoInfoRect.width / 2 + "px";
    },
    moveLogoInfoToElement(element, text) {
      if (this.$refs.logoInfo == null || this.$refs.logoInfo.style == null)
        return;

      this.$refs.logoInfo.style.display = "block";
      this.$refs.logoInfo.innerHTML = text;
      let targetRect = element.getBoundingClientRect();
      let logoInfoRect = this.$refs.logoInfo.getBoundingClientRect();
      this.$refs.logoInfo.style.top =
        targetRect.top +
        targetRect.height / 2 -
        logoInfoRect.height / 2 +
        window.scrollY +
        "px";
      this.$refs.logoInfo.style.left =
        targetRect.left + targetRect.width / 2 - logoInfoRect.width / 2 + "px";
    },
    hideLogoInfo() {
      if (this.$refs.logoInfo == null || this.$refs.logoInfo.style == null)
        return;

      this.$refs.logoInfo.style.display = "none";
    },
    buttonsAnimation() {
      let _this = this;
      let timeLine = anime.timeline({
        easing: "linear",
        duration: 800,
        delay: 1000,
      });

      timeLine
        .add({
          targets: "#logoSoftware",
          begin: function (anim) {
            anim.animatables[0].target.classList.add("hover");
            _this.moveLogoInfoToElement(anim.animatables[0].target, "software");
          },
          complete: function (anim) {
            anim.animatables[0].target.classList.remove("hover");
            _this.hideLogoInfo();
          },
        })
        .add({
          targets: "#logoServices",
          begin: function (anim) {
            anim.animatables[0].target.classList.add("hover");
            _this.moveLogoInfoToElement(anim.animatables[0].target, "service");
          },
          complete: function (anim) {
            anim.animatables[0].target.classList.remove("hover");
            _this.hideLogoInfo();
          },
        })
        .add({
          targets: "#logoHardware",
          begin: function (anim) {
            anim.animatables[0].target.classList.add("hover");
            _this.moveLogoInfoToElement(anim.animatables[0].target, "hardware");
          },
          complete: function (anim) {
            anim.animatables[0].target.classList.remove("hover");
            _this.hideLogoInfo();
          },
        });
    },
  },
  mounted() {
    setTimeout(() => {
      this.buttonsAnimation();
    }, 1000);
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.home {
  height: 100%;
  width: 100%;

  .fullscreen-bg {
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
    overflow: hidden;
    //  background: #B60000;
    /* background: url("../assets/images/cri1.jpg") no-repeat;
      background-size: cover;
      background-position: center bottom;*/

    .fullscreen-video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .missionText {
    grid-column-start: 2;
    grid-row-start: 3;
    font-weight: 900;
    text-align: center;
    align-self: center;
    font-size: 26px;
    color: #0f1213;

    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;

    @media only screen and (max-width: 1366px) {
      font-size: 18px;
    }
  }

  .imagesContainer {
    position: absolute;
    left: 50px;
    top: 50px;
    display: flex;
    flex-direction: column;

    @media only screen and (max-width: 768px) {
      left: 25px;
      bottom: 20px;
      top: auto;
      flex-direction: row;
      width: calc(100% - 50px);
      justify-content: space-evenly;
      align-items: center;
    }

    & > .imgPartner > img {
      width: 200px;
      margin: 0 0 10px 0;

      @media only screen and (max-width: 768px) {
        width: 100px;
      }
    }
  }

  .logoContainer {
    display: grid;
    grid-template-columns: 1fr 60% 1fr;
    grid-template-rows: 1fr 60% 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    height: 100%;
    width: 100%;

    @media only screen and (max-width: 768px) {
      grid-template-columns: 6fr 80% 1fr;
      grid-template-rows: 1fr 80% 1fr;
    }

    .logoInfo {
      position: absolute;
      pointer-events: none;
      display: none;
      font-weight: 900;
      color: #fff;
      font-size: 1.1rem;
    }

    .svgLogo {
      grid-area: 2 / 2 / 3 / 3;
      width: 100%;
      height: 100%;
      overflow: visible;

      #layer93 {
        pointer-events: bounding-box;
      }

      #layerPage {
        pointer-events: bounding-box;

        &:hover {
          fill: #eb222b;
          cursor: pointer;
        }
      }

      .redHoverAndZoom {
        transition: 0.2s ease-in-out;
        transform-origin: 50% 50%;
        transform-box: fill-box;

        &.hover,
        &:hover {
          fill: #eb222b;
          cursor: pointer;
          transform: scale(1.5);
        }
      }
    }

    .bottomMenu {
      position: absolute;
      top: 50px;
      right: 50px;
      height: 30px;

      @media only screen and (max-width: 768px) {
        bottom: 25px;
        right: 25px;
        left: 25px;
      }

      .bottomLink {
        text-transform: uppercase;
        font-weight: 900;
        color: #000;
        padding-left: 10px;
        vertical-align: middle;
        line-height: 1;

        &:hover {
          color: #eb222b;
        }
      }
    }
  }
}
</style>